import React from 'react';

import AdvertList from '@Components/Advert/AdvertList';
import SearchItemsContentLoader from '@Components/Loaders/SearchItemsContentLoader';
import { useGetRelatedAdvertsQuery } from '@Graphql/graphqlTypes.generated';

interface RelatedAdvertsProps {
  itemsCount: number;
  advertId: string;
}

const RelatedAdverts: React.FunctionComponent<RelatedAdvertsProps> = ({ itemsCount, advertId }) => {
  const { data, loading } = useGetRelatedAdvertsQuery({
    variables: { advertId, amount: itemsCount },
    fetchPolicy: 'network-only',
  });

  return (
    <div>
      {loading ? (
        <SearchItemsContentLoader count={itemsCount} gridSize={itemsCount} />
      ) : (
        <AdvertList adverts={data?.relatedAdverts || []} />
      )}
    </div>
  );
};

export default RelatedAdverts;
